import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const OPTIONS = [
  { value: 'None',         label: 'None'          },
  { value: 'Rectangle',    label: 'Rectangle'     },
  { value: 'Ellipse',      label: 'Ellipse'       },
  { value: 'Half-Round',   label: 'Half-Round'    },
  { value: 'CamberedTop',  label: 'Cambered Top'  },
  { value: 'DoubleTransom',label: 'Double Transom'},
];

// Rectangle and Ellipse show children; None hides everything
const SHOWS_CHILDREN = ['Rectangle', 'Ellipse'];

const DEFAULT = 'None';

const Transom = ({ value = { value: '', label: '' }, onChange, disabled = false, onChildrenVisible }) => {
  const [selected, setSelected] = useState(value?.value || DEFAULT);

  useEffect(() => { setSelected(value?.value || DEFAULT); }, [value?.value]);

  const handleChange = (e) => {
    const v = e.target.value;
    const label = OPTIONS.find(o => o.value === v)?.label || v;
    setSelected(v);
    onChange({ value: v, label });
    onChildrenVisible?.(SHOWS_CHILDREN.includes(v));
  };

  return (
    <div className="a-container">
      <label htmlFor="SdTransom">Transom</label>
      <select id="SdTransom" value={selected} onChange={handleChange} disabled={disabled}>
        {OPTIONS.map(o => (
          <option key={o.value} value={o.value}>
            {selected === o.value ? `${o.label} ✔` : o.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Transom;
